import React from 'react';

import { ChevronRightIcon } from '@app/components/icons';

import { CardTabOverlay } from '../card-tab-overlay-container';

export const PurchaseOverlayContainer = ({
	children,
	onClose,
	show,
	title,
	showCartButton,
	setContainerHeight,
	tabType,
	isPpaEnrollment = false,
	myCoursesUrl = '/courses-exams',
}) => (
	<CardTabOverlay
		show={show}
		onClose={onClose}
		setContainerHeight={setContainerHeight}
		tabType={tabType}
	>
		<p className="u-font-family-primary course-panel__title course-panel__title--overlay">
			{isPpaEnrollment ? (
				<>
					{title}{' '}
					<strong>
						You have been enrolled. Go to{' '}
						<a href={myCoursesUrl}>My Courses</a> to access it.
					</strong>
				</>
			) : (
				<>
					{title} <strong>has been added to your cart.</strong>
				</>
			)}
		</p>

		{children}

		{showCartButton && (
			<div className="u-margin-top course-overlay__text-link">
				<a href="/cart" className="btn btn--icon btn--text" title="Cart">
					<span>
						Continue to Cart
						<ChevronRightIcon />
					</span>
				</a>
			</div>
		)}
	</CardTabOverlay>
);
